<template>
    <div v-if="Object.keys(itemDetailActivity).length">
        <data-table
            :headers="defaultHeaders"
            :item-detail-activity="itemDetailActivity"
            module="order" />
    </div>
</template>

<script lang="ts" setup>
import DataTable from './table.vue'
const props = defineProps({
  itemDetailActivity: {
    type: Object,
    default: () => {}
  }
})
const store = $store()
const { itemDetailActivity } = toRefs(props)

const labelResponsibleForImplementation = (type: string) => {
  const workspaceName = store.system.workspace.name
  if (type === 'HEADWAY') {
    return workspaceName + ' - ' + $t('labels.other')
  }
  if (type === 'HEADWAY_DRIVER') {
    return workspaceName + ' - ' + $t('labels.driver')
  }
  if (type === 'CUSTOMER') {
    return $t('labels.customer')
  }
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const labelListOrderForm = {
  QUOTE: $t('labels.quote'),
  CUSTOMER_REQUEST: $t('labels.customerRequest')
}

const defaultHeaders: { [key: string]: any } = {
  createOrderFrom: {
    label: $t('labels.createOrderFrom'),
    valueFormatter: (data: string) => {
      if (data === 'CUSTOMER_REQUEST') {
        return $t('labels.customerRequest')
      } else if (data === 'QUOTE') {
        return $t('labels.quote')
      } else {
        return ''
      }
    }
  },
  quoteCode: {
    label: $t('labels.quote'),
    type: 'string'
  },
  customerName: {
    label: $t('labels.customer'),
    type: 'string'
  },
  contactName: {
    label: $t('labels.contact'),
    type: 'string'
  },
  businessOpportunityName: {
    label: $t('labels.businessOpportunity'),
    type: 'string'
  },
  commodityName: {
    label: $t('labels.commodity'),
    type: 'string'
  },
  workflowName: {
    label: $t('labels.workflow'),
    type: 'string'
  },
  contCategory: {
    label: $t('labels.cont'),
    valueFormatter: (data: number) => {
      if ($lodash.isNil(data)) {
        return null
      }
      return listLabelCont[data] || '...'
    }
  },
  vehicleCategoryName: {
    label: $t('labels.vehicleType'),
    type: 'string'
  },
  productivity: {
    label: $t('labels.productivityByMount'),
    type: 'number'
  },
  weightCommodity: {
    label: $t('labels.weightCommodityByKG1'),
    type: 'number'
  },
  request: {
    label: $t('labels.note'),
    type: 'string'
  },
  status: {
    label: $t('labels.status'),
    type: 'status'
  },
  chargeName: {
    label: $t('labels.route'),
    type: 'string'
  },
  productivityOrder: {
    label: $t('labels.productivity'),
    type: 'number'
  },
  workingTimeRequest: {
    label: $t('labels.workingTimeRequest'),
    valueFormatter: (items: Array<string>) => {
      if (Array.isArray(items) && items.length) {
        const results = items.map((data: string) => {
          switch (data) {
          case 'overTime':
            return $t('labels.nodeModule.overTime')
          case 'weekend':
            return $t('labels.nodeModule.weekend')
          case 'holiday':
            return $t('labels.holiday')
          default:
            return ''
          }
        })
        return results.join(',')
      }
      return ''
    }
  },
  mergeContainer: {
    label: $t('labels.mergeContainer'),
    valueFormatter: (data: boolean) => {
      if (typeof data !== 'boolean') {
        return ''
      }
      if (data) {
        return $t('labels.true')
      }
      return $t('labels.false')
    }
  },
  headContainer: {
    label: $t('labels.headContainer'),
    valueFormatter: (data: boolean) => {
      if (typeof data !== 'boolean') {
        return ''
      }
      if (data) {
        return $t('labels.true')
      }
      return $t('labels.false')
    }
  }
}
</script>

<style scoped></style>
